module.exports = __webpack_public_path__ + "static/media/burger-hamsey-carousel.50805586.jpg";